<!--
 * @Description: 
 * @Date: 2022-09-19 11:03:48
-->
<template>
  <div>
    <div class="item" v-for="(item, index) in _data" :key="item.id">
      <div class="title">
        <span class="name">
          {{
            `${item.name}${
              item.source !== TAG_SOURCE_SYSTEM
                ? item.optionType == OPTION_TYPE_RADIO
                  ? '（单选）'
                  : '（多选）'
                : ''
            }`
          }}
        </span>
        <BaseSwitch :disabled="disabled" v-model="item.required"></BaseSwitch>
        <span class="must-tips">{{ item.required ? '必填' : '非必填' }}</span>
        <BaseButton
          :disabled="disabled"
          type="info"
          link
          @click="_data.splice(index, 1)"
        >
          <BaseIcon color="#777" :size="18">
            <DeleteFilled></DeleteFilled>
          </BaseIcon>
        </BaseButton>
        <template v-if="item.isLocation">
          <BaseCascader
            style="width: 300px"
            :disabled="disabled"
            v-model="item.chooseTagValues"
            @change="addressDataChange"
            multiple
            :options="addressData"
            clearable
            collapse-tags
          ></BaseCascader>
        </template>
      </div>
      <div class="content">
        <template v-if="item.isLocation">
          <div class="values" style="max-height: 200px; overflow: auto">
            <template
              v-if="
                item.chooseTagValues?.length && item.chooseTagValues?.length > 0
              "
            >
              <div
                class="value address-value"
                v-for="{
                  provinceId,
                  cityId,
                  value,
                  index
                } in item.chooseTagValuesStr"
                :key="index"
              >
                <span>{{ value }}</span>
                <BaseButton
                  :disabled="disabled"
                  type="info"
                  link
                  class="del"
                  @click="
                    () => {
                      if (provinceId) {
                        if (cityId) {
                          item.chooseTagValues = item.chooseTagValues.filter(
                            data => data[0] != provinceId || data[1] != cityId
                          );
                        } else {
                          item.chooseTagValues = item.chooseTagValues.filter(
                            data => data[0] != provinceId
                          );
                        }
                      }
                      addressDataChange();
                    }
                  "
                >
                  <BaseIcon><CircleCloseFilled></CircleCloseFilled></BaseIcon>
                </BaseButton>
              </div>
            </template>
            <div v-else>暂未选择需求地点</div>
          </div>
        </template>
        <template v-else>
          <BaseCheckboxGroup class="values" v-model="item.chooseTagValues">
            <BaseCheckbox
              :disabled="disabled"
              class="value"
              v-for="value in item.childList"
              :value="value.id"
              :key="value.id"
            >
              {{ value.name }}
            </BaseCheckbox>
          </BaseCheckboxGroup>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { computed, watch, ref } from 'vue';
import { TagType } from '../../data-source/types';
import {
  BaseButton,
  BaseCascader,
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseIcon,
  BaseSwitch
} from 'xrk-components';
import { CircleCloseFilled, DeleteFilled } from '@element-plus/icons-vue';
import { cloneDeep } from 'lodash';
import { useProvince } from '../../hooks/use-province';
import { OPTION_TYPE_RADIO, TAG_SOURCE_SYSTEM } from '../../config';

const emits = defineEmits<{ (event: 'change', data: Array<TagType>): void }>();
const props = defineProps<{
  data: Array<TagType>;
  disabled: boolean;
}>();

const _data = ref(cloneDeep(props.data));

const { addressData, addressDataChange } = useProvince(
  computed(() => _data.value.filter(item => item.isLocation)?.[0])
);

watch(
  () => _data.value,
  newV => {
    emits('change', newV);
  },
  { deep: true }
);

defineExpose({
  initAddressData: addressDataChange
});
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  gap: 12px;
  font-size: 14px;
  align-items: center;
  .name {
    color: #333;
  }
  .must-tips {
    color: #666;
  }
}
.content {
  border-radius: 4px;
  border: 1px solid #d8dce6;
  margin-top: 8px;
  .values {
    display: flex;
    padding: 12px 16px;
    color: #666666;
    font-size: 14px;
    flex-wrap: wrap;
    gap: 14px;
    .address-value {
      display: flex;
      gap: 4px;
      align-items: center;
      padding: 4px 8px;
      background-color: #f5f7fa;
      border-radius: 4px;
      .del {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }
  }
}
.item + .item {
  margin-top: 16px;
}
::v-deep {
  .xrk-cascader__tags {
    gap: 5px;
    padding: 0 5px;
    .xrk-tag {
      margin: 0;
    }
  }
}
</style>
